export default {"src":"/_next/static/media/teeth-right.e06c2590.svg","height":162,"width":68,"blurWidth":0,"blurHeight":0};